import { createListenerMiddleware } from "@reduxjs/toolkit";

export const appListenerMiddleware = createListenerMiddleware();
